module.exports = __webpack_public_path__ + "static/media/img-1.a125c784.png";